import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./BreakdownChartStyles";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ReferenceLine
} from "recharts";
import { colour } from "../style/base-theme";
import ReferenceLabel from "../components/ReferenceLabel";
import AxisLabel from "../components/AxisLabel";
import { energyActions } from "../_actions";
import moment from "moment";

export default class BreakdownChart extends Component {
  render() {
    const {
      chartExpanded,
      detail,
      detail: { details }
    } = this.props.energy;

    let momentFormat,
      referenceFormat,
      referenceItem,
      referenceValue,
      tickPositions,
      // data = [
      //   { name: "12am", generated: 15, cost: -11, consumed: 4 },
      //   { name: "1am", generated: 13, cost: -10, consumed: 3 },
      //   { name: "2am", generated: 10, cost: -8, consumed: 2 },
      //   { name: "3am", generated: 5, cost: -3, consumed: 2 },
      //   { name: "4am", generated: 7, cost: -5, consumed: 2 },
      //   { name: "5am", generated: 9, cost: -6, consumed: 3 },
      //   { name: "6am", generated: 4, cost: 1, consumed: 5 },
      //   { name: "7am", generated: 7, cost: 0, consumed: 7 },
      //   { name: "8am", generated: 10, cost: -3, consumed: 7 },
      //   { name: "9am", generated: 12, cost: -3, consumed: 9 },
      //   { name: "10am", generated: 12, cost: 4, consumed: 16 },
      //   { name: "11am", generated: 13, cost: 2, consumed: 15 },
      //   { name: "12pm", generated: 7, cost: 6, consumed: 13 },
      //   { name: "1pm", generated: 5, cost: 10, consumed: 15 },
      //   { name: "2pm", generated: 5, cost: 10, consumed: 15 },
      //   { name: "3pm", generated: 5, cost: 9, consumed: 14 },
      //   { name: "4pm", generated: 6, cost: 7, consumed: 13 },
      //   { name: "5pm", generated: 7, cost: 7, consumed: 14 },
      //   { name: "6pm", generated: 7, cost: 5, consumed: 12 },
      //   { name: "7pm", generated: 8, cost: 3, consumed: 11 },
      //   { name: "8pm", generated: 9, cost: -3, consumed: 6 },
      //   { name: "9pm", generated: 9, cost: -3, consumed: 6 },
      //   { name: "10pm", generated: 9, cost: -3, consumed: 6 },
      //   { name: "11pm", generated: 9, cost: -3, consumed: 6 },
      //   { name: "12pm", generated: 9, cost: -3, consumed: 6 }
      // ],
      data = [],
      title;

    if (detail.period.time_unit === "hour") {
      momentFormat = "mm";
      referenceFormat = "h:mma";
      title = "This Hour";
    } else if (detail.period.time_unit === "day") {
      momentFormat = "ha";
      referenceFormat = "h:mma";
      title = "Today";
    } else if (detail.period.time_unit === "week") {
      momentFormat = "ddd";
      referenceFormat = "ddd h:mma";
      title = "This Week";
    } else if (detail.period.time_unit === "month") {
      momentFormat = "Do";
      referenceFormat = "Do h:mma";
      title = "This Month";
    }

    details.map(detail => {
      const hasGenerated = detail.balance && detail.balance.income;
      return data.push({
        name: moment.unix(detail.period.start_timestamp).format(momentFormat),
        generated: hasGenerated ? detail.balance.income : null,
        cost: detail.balance && detail.balance.profit_loss,
        consumed: hasGenerated ? detail.balance.cost : null,
        timestamp: detail.period.start_timestamp
      });
    });

    for (var i = data.length - 1; i >= 0; i--) {
      if (i === data.length - 1 && data[i].cost) break;
      if (!referenceItem && data[i].cost) {
        referenceItem = i;
        referenceValue = data[i].timestamp;
      }
    }

    if (detail.period.time_unit === "hour") {
      tickPositions = [
        data[10].name,
        data[20].name,
        data[30].name,
        data[40].name,
        data[50].name
      ];
    } else if (detail.period.time_unit === "day") {
      tickPositions = [
        data[3].name,
        data[9].name,
        data[15].name,
        data[21].name
      ];
    } else if (detail.period.time_unit === "week") {
      tickPositions = [data[1].name, data[3].name, data[5].name];
    } else if (detail.period.time_unit === "month") {
      tickPositions = [
        data[6].name,
        data[12].name,
        data[18].name,
        data[24].name
      ];
    }

    return (
      <div
        className={css(
          styles.chartWrapper,
          chartExpanded && styles.expandedWrapper
        )}
        onClick={() => this.props.dispatch(energyActions.toggleExpander())}
      >
        {chartExpanded && (
          <span className={css(styles.chartTitle)}>{`${title}'s Energy`}</span>
        )}
        <ResponsiveContainer>
          <LineChart
            width={600}
            height={300}
            data={data}
            margin={{ top: 15, right: 20, left: -20, bottom: 0 }}
          >
            {chartExpanded && (
              <XAxis
                dataKey="name"
                interval="preserveStartEnd"
                tickLine={false}
                ticks={tickPositions}
                stroke={colour.grey[300]}
                fontFamily="Source Sans Pro"
                fontSize={14}
              />
            )}
            {chartExpanded && (
              <YAxis
                tickLine={false}
                stroke={colour.grey[300]}
                fontFamily="Source Sans Pro"
                fontSize={14}
                label={
                  <AxisLabel value="£" fill={colour.grey[400]} fontSize={14} />
                }
              />
            )}
            {chartExpanded && <CartesianGrid stroke={colour.grey[500]} />}
            {chartExpanded && (
              <ReferenceLine
                x={data[referenceItem] && data[referenceItem].name}
                stroke={colour.grey[400]}
                label={
                  <ReferenceLabel
                    value={`${moment
                      .unix(referenceValue)
                      .format(referenceFormat)} (Latest)`}
                    fill={colour.grey[300]}
                  />
                }
                strokeDasharray="3 3"
              />
            )}
            <Line
              type="monotone"
              dataKey="generated"
              stroke={colour.brand.blue}
              dot={data[1].generated ? false : true}
            />
            <Line
              type="monotone"
              dataKey="cost"
              stroke={colour.energy.primaryGradientTop}
              dot={data[1].cost ? false : true}
            />
            <Line
              type="monotone"
              dataKey="consumed"
              stroke={colour.assisted.primaryGradientTop}
              dot={data[1].consumed ? false : true}
            />
          </LineChart>
        </ResponsiveContainer>
        <div
          className={css(
            styles.expanderWrapper,
            chartExpanded && styles.expanderExpanded
          )}
        >
          <span className={css(styles.chartExpander)}>
            {chartExpanded ? "Collapse" : "Expand"}{" "}
            <i className={css(styles.icon)}>{chartExpanded ? "×" : "+"}</i>
          </span>
        </div>
      </div>
    );
  }
}
